import {sendCargoEvent} from "./eventUtils";
import {showNotify} from "./getData";

export function initElectronEvent(that) {
  if (!envElectron()){
    return;
  }
  //开启或关闭接口服务
  window.ipcRenderer.send("controlDWSServer", that.localCache.outDeviceModel === 3?"open":"close");
  //开启服务后 显示开放的接口
  window.ipcRenderer.on("DWSServerInfo", (event, arg) => {
    that.dwsWeightNodeJsIP = arg;
    that.showDWSSettingInfoClick();
  });
  //读取货物信息
  window.ipcRenderer.on("DWSCargoInfo", (event, arg) => {
    sendCargoEvent(arg);
  });
  //提示信息
  window.ipcRenderer.on("msgListener",(event,arg)=>{
    showNotify(that,arg);
  })
}

export function getPortList(func) {
  window.ipcRenderer.on("serialPortList", (event, arg) => {
    func(arg)
  });
  window.ipcRenderer.send("getPcPortList", "");  //开启服务后 显示开放的接口

}

export function envElectron() {
  return !!window.ipcRenderer
}



// WEBPACK FOOTER //
// ./src/api/electronUtils.js